import React from "react";

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

// The EMANAC mark: five dots in a cross, brand blue at the centre.
export function Mark({ className = "mark" }) {
  return (
    <svg className={className} viewBox="0 0 40 40" aria-hidden="true">
      <circle cx="20" cy="20" r="18.4" fill="none" stroke="currentColor" strokeWidth="1.1" />
      <circle cx="11" cy="20" r="3.6" fill="currentColor" />
      <circle cx="29" cy="20" r="3.6" fill="currentColor" />
      <circle cx="20" cy="11" r="3.6" fill="currentColor" />
      <circle cx="20" cy="29" r="3.6" fill="currentColor" />
      <circle cx="20" cy="20" r="3.6" fill="var(--brand)" />
    </svg>
  );
}

// Arrow for buttons and links; inherits the text colour.
export const Arrow = () => (
  <svg className="arrow" viewBox="0 0 18 18" aria-hidden="true">
    <path d="M3.5 9h11M10 4.5 14.5 9 10 13.5" {...stroke} strokeWidth="1.8" />
  </svg>
);

export const CodeIcon = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path d="m11 9-7 7 7 7M21 9l7 7-7 7M18.5 6l-5 20" {...stroke} strokeWidth="2" />
  </svg>
);

export const PillarIcon = ({ name }) => {
  if (name === "learn")
    return (
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path d="M2.5 12 16 5.5 29.5 12 16 18.5z" {...stroke} />
        <path d="M8 15v6.5c2.2 2 5 3 8 3s5.8-1 8-3V15M29.5 12v8" {...stroke} />
      </svg>
    );
  if (name === "community")
    return (
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <circle cx="16" cy="7" r="3.2" {...stroke} />
        <circle cx="6.5" cy="23.5" r="3.2" {...stroke} />
        <circle cx="25.5" cy="23.5" r="3.2" {...stroke} />
        <path d="M14.2 9.8 8.3 20.7M17.8 9.8l5.9 10.9M9.7 23.5h12.6" {...stroke} />
      </svg>
    );
  return <CodeIcon />;
};

export const Pin = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M10 18s-6-6.3-6-10.5a6 6 0 1 1 12 0C16 11.7 10 18 10 18z" {...stroke} />
    <circle cx="10" cy="7.6" r="2.1" {...stroke} />
  </svg>
);

export const Phone = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="M6.6 2.5h-2a1.6 1.6 0 0 0-1.6 1.8c.9 7 5.7 11.8 12.7 12.7a1.6 1.6 0 0 0 1.8-1.6v-2l-3.4-1.4-1.7 1.7a10 10 0 0 1-4.6-4.6l1.7-1.7z" {...stroke} />
  </svg>
);

export const Mail = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <rect x="2.5" y="4.5" width="15" height="11" rx="2" {...stroke} />
    <path d="m3 5.5 7 5.5 7-5.5" {...stroke} />
  </svg>
);

const SOCIAL_PATHS = {
  LinkedIn:
    "M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9.75h4v11H3zm6.5 0h3.8v1.5h.06c.53-1 1.84-1.85 3.79-1.85 4.05 0 4.85 2.5 4.85 5.9v5.45h-4v-4.83c0-1.15-.02-2.63-1.6-2.63-1.6 0-1.85 1.25-1.85 2.55v4.91h-4z",
  X: "M17.75 3h3.07l-6.7 7.63L22 21h-6.17l-4.84-6.3L5.46 21H2.39l7.17-8.16L2 3h6.33l4.37 5.75zm-1.08 16.17h1.7L7.4 4.73H5.58z",
  Instagram:
    "M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm5.85-7.8a1.07 1.07 0 1 1-2.14 0 1.07 1.07 0 0 1 2.14 0zM12 3.6c2.73 0 3.05.01 4.13.06 2.77.13 4.06 1.44 4.19 4.19.05 1.08.06 1.4.06 4.15s-.01 3.07-.06 4.15c-.13 2.75-1.42 4.06-4.19 4.19-1.08.05-1.4.06-4.13.06s-3.06-.01-4.14-.06c-2.78-.13-4.06-1.45-4.19-4.19-.05-1.08-.06-1.4-.06-4.15s.01-3.07.06-4.15C3.8 5.1 5.08 3.8 7.86 3.66 8.94 3.61 9.27 3.6 12 3.6z",
  Facebook:
    "M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22c4.78-.76 8.43-4.92 8.43-9.94z",
  YouTube:
    "M21.58 7.19a2.5 2.5 0 0 0-1.77-1.77C18.25 5 12 5 12 5s-6.25 0-7.81.42a2.5 2.5 0 0 0-1.77 1.77C2 8.75 2 12 2 12s0 3.25.42 4.81a2.5 2.5 0 0 0 1.77 1.77C5.75 19 12 19 12 19s6.25 0 7.81-.42a2.5 2.5 0 0 0 1.77-1.77C22 15.25 22 12 22 12s0-3.25-.42-4.81zM10 15V9l5.2 3z",
};

export const Social = ({ name }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d={SOCIAL_PATHS[name]} fill="currentColor" fillRule="evenodd" />
  </svg>
);
